import React, { useState } from "react";

export default function AskForm({
  onSubmit,
  isLoading,
  isReadingFiles,
  onAttachFiles,
  attachments,
  onRemoveAttachment,
  onClearAttachments,
  defaultQuestion
}) {
  const [question, setQuestion] = useState(defaultQuestion);

  const canSubmit = Boolean(question.trim()) && !isLoading && !isReadingFiles;

  return (
    <form
      className="ask-form"
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit({
          question: question.trim()
        });
      }}
    >
      <div className="form-head">
        <div>
          <div className="section-kicker">Workspace</div>
          <h2>Ask with attached documents</h2>
        </div>
        <p className="form-note">
          Attach files for the current question. Uploaded objects are treated as temporary context.
        </p>
      </div>

      <div className="upload-shell">
        <input
          id="document-upload"
          type="file"
          accept=".pdf,.txt,.md,.csv,.json,.html,.doc,.docx"
          multiple
          onChange={(event) => {
            if (event.target.files) {
              onAttachFiles(event.target.files);
              event.target.value = "";
            }
          }}
          disabled={isLoading || isReadingFiles}
          className="visually-hidden"
        />
        <label htmlFor="document-upload" className="upload-button">
          {isReadingFiles ? "Reading documents..." : "Attach documents"}
        </label>
        <button
          type="button"
          className="ghost-button clear-attachments"
          onClick={onClearAttachments}
          disabled={attachments.length === 0}
        >
          Clear attachments
        </button>
      </div>

      <div className="attachment-summary" aria-live="polite">
        {attachments.length === 0 ? (
          <p className="attachment-empty">
            No documents attached yet. Attach one or more files to anchor the next question.
          </p>
        ) : (
          attachments.map((attachment) => (
            <div key={attachment.id} className="attachment-chip">
              <div>
                <strong>{attachment.name}</strong>
                <span>
                  {attachment.type} · {attachment.sizeLabel}
                </span>
              </div>
              <button
                type="button"
                className="chip-remove"
                onClick={() => onRemoveAttachment(attachment.id)}
                aria-label={`Remove ${attachment.name}`}
              >
                Remove
              </button>
            </div>
          ))
        )}
      </div>

      <label className="field-label" htmlFor="question">
        Question
      </label>
      <textarea
        id="question"
        value={question}
        onChange={(event) => setQuestion(event.target.value)}
        placeholder="What decisions in this system matter most to an interviewer?"
        rows={6}
      />

      <div className="form-row">
        <button type="submit" disabled={!canSubmit}>
          {isLoading ? "Querying..." : "Run query"}
        </button>
        <p className="form-note">
          The answer path uses the current `v2` route. `v1` remains available for compatibility.
        </p>
      </div>
    </form>
  );
}
